import { mapMutations, mapState } from 'vuex'

import get from 'lodash/get'
import compact from 'lodash/compact'
import includes from 'lodash/includes'
import has from 'lodash/has'

import firebase from 'firebase/app'
import 'firebase/database'

export default {
  data() {
    return {
      liveArticleNid: '',
      databaseRef: null,
      databasePath: '',
      databaseMode: '', // live / push
    }
  },
  computed: {
    ...mapState(['registeredLiveArticles']),
    firebaseConfig() {
      return get(this.$store.state, 'settings.FCM_CONFIG', false)
    },
  },
  methods: {
    ...mapMutations([
      'setNodeLiveContent',
      'setNodeLiveStatus',
      'appendRegisteredLiveArticles',
      'updateNotificationList',
    ]),
    initRealtimeData({modeType, nid = ''}) {
      this.databaseMode = modeType

      switch (this.databaseMode) {
        case 'live': {
          if (nid) {
            this.liveArticleNid = nid

            // set only once per nid
            if (!includes(this.registeredLiveArticles, this.liveArticleNid)) {
              this.appendRegisteredLiveArticles(this.liveArticleNid)
              this.setDatabaseRef({path: `/node_status/${this.liveArticleNid}`})
            }
          }
          break
        }
        case 'push': {
          this.setDatabaseRef({path: 'notification_list'})
          break
        }
        default: // Do nothing
      }

      this.listenToDatabase()
    },
    setDatabaseRef({path}) {
      // Init firebase
      if (!firebase.apps.length) firebase.initializeApp(this.firebaseConfig)

      // Set path of database reference
      this.databaseRef = firebase.database().ref(path)

      console.log(`[Realtime - ${this.databaseMode}] ${get(this, 'databaseRef') ? 'connected' : 'not connected'} ${get(this, 'liveArticleNid')}`)
    },
    listenToDatabase() {
      if (get(this, 'databaseRef')) {
        this.databaseRef.orderByKey().on('value', this.updateState, (err) => {
          console.log('[Realtime - Error]', err)
        })
      }
    },
    updateState(snapshot) {
      const dataObj = snapshot.val()
      if (dataObj !== null) { // If database is empty, null is returned
        switch (this.databaseMode) { // Set vue states depending on mode
          case 'live': {
            if (has(dataObj, 'status')) {
              this.setNodeLiveStatus({ nid: this.liveArticleNid, status: dataObj.status})
            }
            if (has(dataObj, 'body')) {
              this.setNodeLiveContent({ nid: this.liveArticleNid, liveContent: compact(dataObj.body)})
            }
            break
          }
          case 'push': {
            this.updateNotificationList(dataObj)
            break
          }
          default: // Do nothing
        }
      }
    },
    destroyRealtimeListener() {
      if (this.databaseRef !== null) this.databaseRef.off('value', this.updateState)
    },
  },
  beforeDestroy() {
    this.destroyRealtimeListener()

    if (this.databaseMode === 'live') {
      this.appendRegisteredLiveArticles(false)
    }
  },
}



// WEBPACK FOOTER //
// ./components/mixins/realtimeData.js